export default __webpack_public_path__ + "static/hero_table-461aa3e8c7e130a07d5797e1aa00db39.webp";